import styled, { css } from 'styled-components/macro';
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { getProfile } from 'src/store/profile/profile.selectors';
import { Header } from 'src/components/Header';
import { profileActions } from 'src/store/profile/profile.actions';
import { useToast } from 'src/components/Toast';
import LoadingIndicator from 'src/components/LoadingIndicator';
import Button from 'src/components/Button';
import { authActions } from 'src/store/auth/auth.actions';
import { company } from 'src/config';
import { getBrandingImage, imageTypes } from 'src/branding';
import { Breadcrumbs } from 'src/components/Breadcrumbs';
import { getUserNeedsToConfirmProfileInformation } from '../../store/auth/auth.selectors';
import { LoginPage, LogoImg } from '../Login/Login';
import { routes } from '../routes.manifest';
import {
  Page, Column, LinkLabel, Row,
} from '../../components/Layout';

export const getBrsvDisplay = (profile) => {
  if (profile.brsv_status === 0) {
    return 'Ukjent';
  } else if (profile.brsv_status === 1) {
    return 'Grønn';
  } else if (profile.brsv_status === 2) {
    return 'Rød';
  } else {
    return '';
  }
};

export const getKsvStatusDisplay = (profile) => {
  if (profile.ksl_status === 0) {
    return 'Ukjent';
  } else if (profile.ksl_status === 1) {
    return 'Godkjent';
  } else if (profile.ksl_status === 2) {
    return 'Ikke godkjent';
  }
};

const Wrapper = styled.div`
  flex: none;
`;

const FieldNameCol = styled.td`
  width: 45%;
  vertical-align: top;
  padding-left: 0px;
`;

const FieldValueCol = styled.td`
  vertical-align: top;
`;

const TableRow = styled.tr`
  border-bottom: 1px solid gray;
  height: 35px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;

  @media screen and (max-width: 500px) {
  }
`;

const MyProfileHeader = styled(Header)`
  @media screen and (min-width: 700px) {
    text-align: center;
  }
`;

export const ConfirmWrapper = styled(Wrapper)`
  background: white;
  width: 394px;
  max-width: 61%;
  height: fit-content;
  padding: 2em;
  opacity: 0.9;
  border-radius: 15px;
  left: calc(50% - 1.2em);

  position: relative;
  top: unset;
  transform: translateX(-50%);
  margin-top: 2em;

  @media screen and (max-width: 400px) {
    width: 100%;
    [name='brsv_bcov_status'] {
      height: 43px;
    }
  }
`;

export const getFormattedAnimalKeepingInfo = (animalKeeping) => Object.getOwnPropertyNames(animalKeeping)
  .filter((p) => ['has_sheep', 'has_pigs', 'has_cattle'].indexOf(p) >= 0)
  .filter((n) => animalKeeping[n])
  .map((a) => animalKindToNorwegian(a))
  .join(', ');

export const getFormattedAnimalRestrictionsInfo = (animalKeeping) => Object.getOwnPropertyNames(animalKeeping)
  .filter(
    (p) => [
      'has_pigs_restriction',
      'has_cattle_restriction',
      'has_sheep_restriction',
    ].indexOf(p) >= 0,
  )
  .filter((n) => animalKeeping[n])
  .map((a) => animalRestrictionKindToNorwegian(a))
  .join(', ');

const animalKindToNorwegian = (kind) => {
  if (kind === 'has_sheep') {
    return 'Småfe';
  } else if (kind === 'has_cattle') {
    return 'Storfe';
  } else if (kind === 'has_pigs') {
    return 'Gris';
  } else {
    return 'Annen type';
  }
};
const animalRestrictionKindToNorwegian = (kind) => {
  if (kind === 'has_sheep_restriction') {
    return 'Småfe';
  } else if (kind === 'has_cattle_restriction') {
    return 'Storfe';
  } else if (kind === 'has_pigs_restriction') {
    return 'Gris';
  } else {
    return 'Annen type';
  }
};
export const Profile = withRouter(({ history: { push } }) => {
  const dispatch = useDispatch();
  const profileSelector = useSelector(getProfile);
  const userNeedsToConfirmProfileInformationSelector = useSelector(
    getUserNeedsToConfirmProfileInformation,
  );

  const userNeedsToConfirmProfileInformation = userNeedsToConfirmProfileInformationSelector.needToConfirm;

  useEffect(() => {
    if (!profile && !profileSelector.isFetching && !profileSelector.error) {
      dispatch(profileActions.fetch());
    }
  }, [dispatch, profile, profileSelector.error, profileSelector.isFetching]);

  const loadingData = profileSelector.isFetching || !profileSelector.profile;
  const profile = profileSelector.profile;
  const toast = useToast();

  const ChoosenPage = userNeedsToConfirmProfileInformation ? LoginPage : Page;
  const ChoosenWrapper = userNeedsToConfirmProfileInformation
    ? ConfirmWrapper
    : Wrapper;

  return (
    <ChoosenPage title="Min Konto" style={{ padding: '1em' }} className={userNeedsToConfirmProfileInformation ? 'confirm-profile-info' : ''}>
      {userNeedsToConfirmProfileInformation && (
        <Row>
          <LogoImg src={getBrandingImage(imageTypes.confirmProfileInfoLogo)} className="desktop logo" />
          <LogoImg src={getBrandingImage(imageTypes.confirmProfileInfoLogoMobile)} className="mobile logo" />
        </Row>
      )}

      <ChoosenWrapper>
        {!userNeedsToConfirmProfileInformation
        && (
          <Breadcrumbs
            className="breadcrumbs"
            breadcrumbs={[{ title: 'Profil', url: '/profile' }]}
            wrapperStyle={css`
            margin-bottom: 1.7rem;
            width: fit-content;
            margin-left: auto;
            margin-right: auto;
            @media (max-width:  700px){
              padding-left: 1em;
              margin-left: 0;
              margin-right: 0;
            }

            `}
          />
        )}

        <MyProfileHeader>
          {userNeedsToConfirmProfileInformation && !loadingData
            ? `Hei, ${profile.fullname}`
            : 'Min Konto'}
        </MyProfileHeader>

        {userNeedsToConfirmProfileInformation && !loadingData && (
          <h3>Vennligst bekreft at følgende informasjon stemmer.</h3>
        )}
        <>
          {(profileSelector.error && (
            <h2>Kunne ikke laste inn profildata.</h2>
          ))
            || (loadingData && (
              <LoadingIndicator
                withText="Laster..."
                style={company === 'midtnorge' ? { position: 'relative', bottom: '1em' } : {}}
                css="padding-top: 1em;"
              />
            )) || (
              <Column
                style={{
                  maxWidth: '531px',
                  width: '100%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Table>
                  <TableRow>
                    <FieldNameCol>Navn:</FieldNameCol>
                    <FieldValueCol>{profile.fullname}</FieldValueCol>
                  </TableRow>
                  <TableRow>
                    <FieldNameCol>Leverandørnr:</FieldNameCol>
                    <FieldValueCol>{profile.supplier_no}</FieldValueCol>
                  </TableRow>
                  <TableRow>
                    <FieldNameCol>Foretaksnr:</FieldNameCol>
                    <FieldValueCol>{profile.company_no}</FieldValueCol>
                  </TableRow>
                  <TableRow>
                    <FieldNameCol>Produsentnr:</FieldNameCol>
                    <FieldValueCol>{profile.provider_no}</FieldValueCol>
                  </TableRow>
                  <TableRow>
                    <FieldNameCol>DyreholdsID:</FieldNameCol>
                    <FieldValueCol>{profile.animal_keeping_id}</FieldValueCol>
                  </TableRow>

                  <TableRow>
                    <FieldNameCol>KSL-status:</FieldNameCol>
                    <FieldValueCol>
                      {getKsvStatusDisplay(profile)}
                    </FieldValueCol>
                  </TableRow>

                  <TableRow name="brsv_bcov_status">
                    <FieldNameCol>BRSV/BCoV-status:</FieldNameCol>
                    <FieldValueCol>{getBrsvDisplay(profile)}</FieldValueCol>
                  </TableRow>

                  {profile.animal_keeping && (
                    <div style={{ display: 'table-row-group' }}>
                      <TableRow>
                        <FieldNameCol>Dyrehold:</FieldNameCol>
                        <div>
                          {getFormattedAnimalKeepingInfo(
                            profile.animal_keeping,
                          )}
                        </div>
                      </TableRow>
                      <TableRow>
                        <FieldNameCol>Restriksjoner:</FieldNameCol>
                        <td>
                          <div>
                            {getFormattedAnimalRestrictionsInfo(
                              profile.animal_keeping,
                            )}
                          </div>
                        </td>
                      </TableRow>
                    </div>
                  )}

                  <TableRow>
                    <FieldNameCol>E-post til leverandør:</FieldNameCol>
                    <FieldValueCol>{profile.email_user}</FieldValueCol>
                  </TableRow>

                  <TableRow>
                    <FieldNameCol>E-post til regnskap:</FieldNameCol>
                    <FieldValueCol>{profile.email_accounting}</FieldValueCol>
                  </TableRow>

                  <TableRow>
                    <FieldNameCol>Mobil:</FieldNameCol>
                    <FieldValueCol>{profile.mobile}</FieldValueCol>
                  </TableRow>
                  <TableRow>
                    <FieldNameCol style={{ verticalAlign: 'top' }}>
                      Adresse:
                    </FieldNameCol>
                    <td>
                      <FieldValueCol
                        as="div"
                        style={{
                          marginBottom: '0.6rem',
                        }}
                      >
                        {profile.street_address}
                      </FieldValueCol>
                      <FieldValueCol
                        as="div"
                        style={{ marginBottom: '0.6rem' }}
                      >
                        {`${profile.post_no || ''} ${profile.city || ''}`}
                      </FieldValueCol>
                    </td>
                  </TableRow>
                </Table>
                {(!userNeedsToConfirmProfileInformation && (
                  <LinkLabel
                    small
                    size="1.3rem"
                    to={routes.profileEdit}
                    style={{ width: 'fit-content', paddingRight: '0.135em', maxWidth: '95px' }}
                  >
                    Endre profil
                  </LinkLabel>
                )) || (
                  <div>
                    <div style={{ marginTop: '2em' }}>
                      <Button
                        secondary
                        style={{ marginRight: '1em' }}
                        onClick={() => push(routes.profileEdit)}
                      >
                        Endre profil
                      </Button>
                      <Button
                        primary
                        onClick={() => dispatch(
                          authActions.userConfirmedProfileInformation({
                            onSuccess: () => {
                              push(routes.dashboard);
                              toast.addMessage('Informasjonen ble bekreftet');
                            },
                            onError: () => {
                              toast.addError(
                                'Kunne ikke bekfrefte informasjonen',
                              );
                            },
                          }),
                        )}
                      >
                        Ok, gå videre
                      </Button>
                    </div>
                    <LinkLabel
                      to={routes.changePw}
                      style={{ marginTop: '0.5em', display: 'block' }}
                    >
                      Endre passord
                    </LinkLabel>
                  </div>
                )}
              </Column>
          )}
        </>
      </ChoosenWrapper>
    </ChoosenPage>
  );
});
